// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"df3d3f8a","453":"35aa040a"}[chunkId] + ".chunk.js";
};